import React, { Fragment, useContext } from 'react'
import { Mutation as MutationComponent } from '@apollo/client/react/components'
import { transformData } from '../utils'
import { StatusIndicatorContext } from '../context/StatusIndicatorContext'

const Mutation = ({ children, onCompleted, withIndicator = true, ...props }) => {
	const { addPromise } = useContext(StatusIndicatorContext)

	const handleOnCompleted = data => {
		if(typeof onCompleted === 'function') {
			const { data: transformedData, ...dataInfo } = transformData(data)
			onCompleted(transformedData, dataInfo)
		}
	}
	const handleMutate = (mutate, { appField, queryField }) => (options = {}) => {
		const { update, ...rest } = options
		let parameters = rest
		if(typeof update === 'function') {
			parameters.update = (cache, { data, ...restUpdateCache }) => {
				const { data: transformedData } = transformData(data)
				return update(cache, {
					...restUpdateCache,
					data: transformedData
				})
			}
		}
		const promise = mutate(parameters)
		addPromise(promise)
		return promise
	}
	return(
		<MutationComponent onCompleted={handleOnCompleted} {...props}>
			{(mutate, { data, loading, error, ...rest }) => {
				const { data: transformedData, ...dataInfo } = transformData(data)
				return(
					<Fragment>
						{children(
							handleMutate(mutate, dataInfo), {
								...rest,
								...dataInfo,
								data: transformedData
							}
						)}
					</Fragment>
				)
			}}
		</MutationComponent>
	)
}

export default Mutation
